module.exports = __webpack_public_path__ + "img/sand-dune-decal-24.f4eda400.png";